import { useLang } from '@/context/LanguageContext';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const HERO_BG = 'https://static.prod-images.emergentagent.com/jobs/1c1c0a12-ef9e-4115-8c24-247b6797c63a/images/c2c2f28674eafc97f026319944f161cac1053fc5a571858e014a9a7fc44f992c.png';

export default function Hero() {
  const { t } = useLang();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-screen flex items-end pb-24 lg:pb-32 overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt=""
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-zinc-950/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 w-full">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-8"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_madison-fred-design/artifacts/zy0qofhd_Copilot_20260414_133202.png"
            alt="MadisonFred - Web Design Agency"
            data-testid="hero-logo"
            className="h-32 sm:h-40 lg:h-52 w-auto"
          />
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="text-6xl sm:text-7xl lg:text-8xl xl:text-9xl font-normal leading-[1.1] text-purple-400 max-w-5xl"
          style={{ fontFamily: "'Great Vibes', cursive" }}
        >
          {t('hero.headline')}
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="mt-8 text-base lg:text-lg font-manrope text-zinc-400 max-w-2xl leading-relaxed"
        >
          {t('hero.sub')}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="mt-12 flex flex-wrap gap-4"
        >
          <button
            data-testid="hero-cta-primary"
            onClick={() => scrollTo('contact')}
            className="group bg-white text-black px-8 py-4 text-sm font-semibold uppercase tracking-wider hover:bg-zinc-200 transition-colors duration-300 flex items-center gap-3"
          >
            {t('hero.cta')}
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </button>
          <button
            data-testid="hero-cta-secondary"
            onClick={() => scrollTo('portfolio')}
            className="border border-white/20 text-zinc-50 px-8 py-4 text-sm font-semibold uppercase tracking-wider hover:border-white/40 hover:bg-white/5 transition-all duration-300"
          >
            {t('hero.cta2')}
          </button>
        </motion.div>
      </div>
    </section>
  );
}
